export default __webpack_public_path__ + "7c036ba7048d6557dde510b5af90113a.png";